import React from 'react';

/**
 * Whether the daily job replaces a custom playbook's picks for every upcoming event (auto_picks).
 * Either way the playbook is scored after each event; with it off, the picks it is scored on are
 * the ones saved by the builder or by Refresh picks.
 */
export default function AutoPicksOption({ checked, onChange, disabled = false, id = 'auto-picks' }) {
  return (
    <label className="option-check" htmlFor={id}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="option-check-text">
        <span className="option-check-title">Update picks automatically every event</span>
        <span className="option-check-note">
          {checked
            ? 'Odikai picks this playbook\'s bets for each new card with the same rules as its own playbooks (they can differ a little from the builder\'s).'
            : 'Your picks stay as saved; use Refresh picks for a new card. They are still scored after each event.'}
        </span>
      </span>
    </label>
  );
}
